import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudOff32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCloudOff32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M25.37 5.225a1 1 0 0 1 1.405 1.406l-.068.076-1.998 1.997a8.46 8.46 0 0 1 2.235 6.775A6 6 0 0 1 23 26H9a6 6 0 0 1-1.415-.173l-1.878 1.88a1 1 0 0 1-1.414-1.415l21-21zM9.413 24H23a4 4 0 0 0 2.629-7.014l-.791-.692.119-1.043q.042-.368.043-.75a6.47 6.47 0 0 0-1.704-4.384zM18.5 6c1.087 0 2.126.206 3.081.578l-1.595 1.595A6.5 6.5 0 0 0 18.5 8a6.47 6.47 0 0 0-4.253 1.585l-.702.608-.918-.144a4 4 0 0 0-4.594 4.47l.172 1.334-1.17.662a4 4 0 0 0-1.252 5.862l-1.425 1.425a5.998 5.998 0 0 1 1.691-9.027 6 6 0 0 1 6.888-6.701A8.47 8.47 0 0 1 18.5 6"
            />
        </svg>
    );
}
export default memo(IconCloudOff32);
